class MediaContentVideo {
	constructor(containerSelector = '.custom-youtube-player') {
		this.containerSelector = containerSelector;
		this.createModal();
	}

	createModal() {
		// Create principal modal
		const modal = document.createElement('div');
		modal.classList.add('custom-video-modal');
		modal.style.cssText = `
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0,0,0,0.8);
			display: none;
			align-items: center;
			justify-content: center;
			padding: 4.5rem;
			box-sizing: border-box;
			z-index: 9999;
		`;

		// Content modal
		const modalContent = document.createElement('div');
		modalContent.classList.add('custom-video-modal__content');
		modalContent.style.cssText = `
			position: relative;
			width: 100%;
			height: 100%;
			background: transparent;
			display: flex;
			align-items: center;
			justify-content: center;
		`;

		// Spinner
		const spinner = document.createElement('div');
		spinner.classList.add('custom-video-spinner');
		spinner.style.cssText = `
			position: absolute;
			width: 60px;
			height: 60px;
			border: 6px solid rgba(255, 255, 255, 0.3);
			border-top-color: white;
			border-radius: 50%;
			animation: spin 1s linear infinite;
			z-index: 10001;
			display: none;
		`;

		//spinner style
		const style = document.createElement('style');
		style.textContent = `
			@keyframes spin {
				to { transform: rotate(360deg); }
			}
		`;
		document.head.appendChild(style);

		// Exit button
		const closeBtn = document.createElement('span');
		closeBtn.innerHTML = '&times;';
		closeBtn.style.cssText = `
			position: absolute;
			top: 0;
			right: -3rem;
			color: white;
			font-size: 3rem;
			cursor: pointer;
			z-index: 10000;
		`;

		// Close events
		closeBtn.addEventListener('click', () => this.closeModal());
		modal.addEventListener('click', (e) => {
			// close modal if the click is in padding
			if (e.target === modal) {
				this.closeModal();
			}
		});

		// Append elements
		modalContent.appendChild(spinner);
		modalContent.appendChild(closeBtn);
		modal.appendChild(modalContent);
		document.body.appendChild(modal);

		// Save refs
		this.modal = modal;
		this.modalContent = modalContent;
		this.spinner = spinner;
	}

	openModal(videoId, params = '') {
		// clean iframes
		this.modalContent.querySelectorAll('iframe').forEach(iframe => iframe.remove());
		
		// show spinner always
		this.spinner.style.display = 'block';

		// Create iframe
		const iframe = document.createElement('iframe');
		iframe.setAttribute('width', '100%');
		iframe.setAttribute('height', '100%');
		iframe.setAttribute('frameborder', '0');
		iframe.setAttribute('allowfullscreen', '');
		iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
		iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;

		// add params
		const queryString = params ? `?${params}` : '?autoplay=1&rel=0';
		iframe.src = `https://www.youtube.com/embed/${videoId}${queryString}`;

		iframe.addEventListener('load', () => {
			this.spinner.style.display = 'none';
		});

		this.modalContent.appendChild(iframe);
		this.modal.style.display = 'flex';
	}

	closeModal() {
		this.modal.style.display = 'none';
		this.spinner.style.display = 'none';
		this.modalContent.querySelectorAll('iframe').forEach(iframe => iframe.remove());
	}

	init() {
		document.querySelectorAll(this.containerSelector).forEach((player) => {
			const videoId = player.getAttribute('data-video-id');
			const params = player.getAttribute('data-params');

			if (!videoId) return;

			const thumbnailHQ = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
			const thumbnailMax = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

			const img = new Image();
			img.src = thumbnailMax;

			img.onerror = () => { img.src = thumbnailHQ; };

			img.alt = "YouTube Thumbnail";
			img.style.width = "100%";
			img.style.height = "auto";

			player.innerHTML = ` <div class="custom-youtube-thumbnail" style="position: relative; cursor: pointer;"> </div> `;
			player.querySelector(".custom-youtube-thumbnail").appendChild(img);
			player.querySelector(".custom-youtube-thumbnail").insertAdjacentHTML(
			"beforeend",
			`<span class="play-button-overlay" style="
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				font-size: 10rem;
				color: white;
				text-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
			">▶</span>`
			);


			player.addEventListener('click', () => {
				this.openModal(videoId, params);
			});
		});
	}
}

export default MediaContentVideo;
